<div [style.height]="height">
    <app-widget-vectormap [mapId]="mapId" [width]="width" type="world" [options]="options">
    </app-widget-vectormap>
</div>